import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/BaseComponents/Page/Page";
import {FaBrandIcon, FaSolidIcon} from "../../components/FontAwesomeIcons";
import GoogleCalendarAPI from "../../api/GoogleCalendarAPI";
import {BookizonAppManager} from "../../index";
import FuxEvents from "../../lib/FuxFramework/FuxEvents";
import {NM_IN_APP_BROWSER_DISMISS} from "../../native/NativeMessageHandler";
import {GoogleCalendarListGroupItem} from "./GoogleCalendarListGroupItem";
import {swal, swalConfirm, swalError, swalLoading, swalSuccess} from "../../helpers/SweetAlertWrapper";
import googleCalendarIcon from "./../../img/brands/google-calendar-icon.svg";
import {BookizonPlusLogo} from "../UserBookizonSubscription/BookizonPlusLogo";

export class GoogleCalendarPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            calendars: [],
        };
    }

    componentDidMount() {
        FuxEvents.on(NM_IN_APP_BROWSER_DISMISS, this.handleBrowserDismiss);
        if (this.props.active) {
            this.fetchCalendars(true);
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.active) {
            this.fetchCalendars(true);
        }
    }

    componentWillUnmount() {
        FuxEvents.off(NM_IN_APP_BROWSER_DISMISS, this.handleBrowserDismiss);
    }


    getSortedCalendars = _ => {
        const calendars = Array.isArray(this.state.calendars) ? [...this.state.calendars] : [];
        return calendars.sort((a, b) => (b?.full_data?.primary || 0) - (a?.full_data?.primary || 0));
    }

    handleBrowserDismiss = _ => {
        if (this.props.active) this.fetchCalendars(false);
    }

    fetchCalendars = (showLoader = true) => {
        if (!this.props.active) return;
        if (showLoader) swalLoading('Attendere prego...');
        GoogleCalendarAPI.getCalendars()
            .then(response => this.setState({calendars: response || []}, _ => swal.safeClose()))
            .catch(swalError);
    }

    openAuthFlow = _ => {
        BookizonAppManager.openInAppBrowser(GoogleCalendarAPI.getAuthLoginUrl());
    }

    handleDelete = calendarId => {
        if (!calendarId) {
            return;
        }
        swalConfirm('Sei sicuro di voler scollegare questo calendario da Bookizon?')
            .then(_ => {

                swalLoading();
                GoogleCalendarAPI.deleteCalendar(calendarId)
                    .then(message => {
                        this.fetchCalendars(false);
                        swalSuccess(message);
                    })
                    .catch(swalError)
            })
    }

    handleDeleteAll = _ => {
        const sortedCalendars = this.getSortedCalendars();
        if (!sortedCalendars.length) {
            return;
        }
        swalConfirm('Sei sicuro di voler scollegare questo calendario da Bookizon?')
            .then(_ => {
                swalLoading();
                Promise.all(sortedCalendars.map(calendar => GoogleCalendarAPI.deleteCalendar(calendar.calendar_id)))
                    .then(_ => this.fetchCalendars())
                    .catch(swalError)
            });
    }

    handleSetDefault = calendarId => {
        if (!calendarId) return;
        swalLoading();
        GoogleCalendarAPI.setDefaultCalendar(calendarId)
            .then(message => {
                swalSuccess(message);
                this.fetchCalendars();
                this.props.onDefaultChange()
            })
            .catch(swalError)
    }

    renderCalendarsList = sortedCalendars => {
        if (this.state.loading) {
            return (
                <div className={"text-center py-5"}>
                    <div className={"spinner-border text-primary mb-3"} role={"status"}>
                        <span className={"sr-only"}>Caricamento...</span>
                    </div>
                    <div className={"text-muted"}>Recupero dei calendari collegati...</div>
                </div>
            );
        }

        if (!sortedCalendars.length) {
            return (
                <div className={"text-center text-muted py-5"}>
                    Non hai ancora sincronizzato alcun calendario Google.
                </div>
            );
        }

        return <React.Fragment>
            <h5 className={"mt-4"}>Scegli un calendario</h5>
            <div className={"list-group"}>
                {sortedCalendars.map(c => <div className={"list-group-item"} key={c.calendar_id}>
                    <GoogleCalendarListGroupItem
                        calendar={c}
                        onDelete={this.handleDelete}
                        onSetDefault={this.handleSetDefault}
                    />
                </div>)}
            </div>
        </React.Fragment>
    }

    render() {
        const sortedCalendars = this.getSortedCalendars();
        return (
            <Page
                active={this.props.active}
                title={"Google Calendar"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                leftIconText={"Indietro"}
                onLeftIconClick={this.props.onDismiss}
            >
                <div className={"container py-3"}>
                    <div className={"card shadow-sm border-0 mb-3"}>
                        <div className={"card-body"}>
                            <img src={googleCalendarIcon} className={"mx-auto d-block mb-3"} height={50}/>
                            <h4 className={"card-title text-center font-weight-bold"}>
                                Collega Google Calendar
                            </h4>
                            <p className={"card-text text-muted"}>
                                Collega Google Calendar a Bookizon per sincronizzare automaticamente le tue prenotazioni
                                sul tuo calendario preferito.
                            </p>
                            <button className={"btn btn-primary btn-block"} onClick={this.openAuthFlow}>
                                <FaBrandIcon name={"google"}/>&nbsp;
                                {sortedCalendars.length ? "Aggiungi altri calendari" : "Accedi con Google"}
                            </button>
                        </div>
                    </div>

                    {this.renderCalendarsList(sortedCalendars)}

                    {
                        !!sortedCalendars.length &&
                        <button
                            className={"btn btn-outline-danger btn-block mt-3"}
                            onClick={this.handleDeleteAll}
                        >
                            Rimuovi tutti i calendari
                        </button>
                    }
                </div>
            </Page>
        );
    }
}

GoogleCalendarPage.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    onDefaultChange: PropTypes.func,
};

GoogleCalendarPage.defaultProps = {
    active: false,
    onDismiss: () => {
    },
    onDefaultChange: () => {
    }
};
